import React from 'react'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { useURLQuerySearch } from 'utils'
import { CWV_ROUTES, isDocumentPrototypeRoute } from 'utils/route'

import { SearchField } from './DocumentNavbar.styles'

const getPlaceholderByPath = (path: string) => {
  if (CWV_ROUTES.includes(path)) {
    return 'Search Components'
  } else if (isDocumentPrototypeRoute(path)) {
    return 'Search Prototypes'
  }

  return 'Search Artboards'
}

interface DocumentNavbarProps
  extends Pick<React.ComponentProps<'input'>, 'onBlur' | 'onFocus'> {}

const DocumentNavbar = (props: DocumentNavbarProps) => {
  const location = useLocation()
  const history = useHistory()
  const { path } = useRouteMatch()

  // Search query param, shared for both artboards and components
  const [search, setSearch] = useURLQuerySearch(location, history)

  return (
    <SearchField
      placeholder={getPlaceholderByPath(path)}
      onChange={setSearch}
      value={search}
      expand={CWV_ROUTES.includes(path) || isDocumentPrototypeRoute(path)}
      {...props}
    />
  )
}

export default DocumentNavbar
